"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var requestBanner_module_scss_1 = __importDefault(require("./requestBanner.module.scss"));
var ButtonCard_1 = require("../buttonCardOpenModal/ButtonCard");
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var RequestBanner = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var brand = props.brand;
    return (react_1.default.createElement("div", { className: requestBanner_module_scss_1.default.request_banner_container },
        react_1.default.createElement("h2", { className: requestBanner_module_scss_1.default.request_banner_title }, "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F ".concat(brand, " \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u043A\u0438\u0434\u043A\u0443")),
        react_1.default.createElement("div", { className: requestBanner_module_scss_1.default.request_banner_btn_wrapper },
            react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443", handler: function () {
                    dispatch((0, modalSlice_1.openModal)('callback'));
                } }))));
};
exports.default = RequestBanner;
